import React from "react";
import PropTypes from "prop-types";
import "../../styles/ErrorMessage.scss";
const ErrorMessage = ({ error }) => {
    return (
        <React.Fragment>
            {error && (
                <div className="error-container">
                    <i className="fa fa-exclamation-circle error-icon"></i>
                    <div className="error-message">{error}</div>
                </div>
            )}
        </React.Fragment>
    )
};

ErrorMessage.propTypes = {
    error: PropTypes.string
}

export default ErrorMessage;
